import { render, staticRenderFns } from "./designSections.vue?vue&type=template&id=0a3ef7cc&scoped=true"
import script from "./designSections.vue?vue&type=script&lang=js"
export * from "./designSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3ef7cc",
  null
  
)

export default component.exports